// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tooltip_wrap__FmTEH {
  display: inline-flex;
}

/* Contenedor fijo (portal) que replica el rect del ancla */
.Tooltip_anchor__EM5eO {
  position: fixed;
  z-index: 1300;
  pointer-events: none;
}

.Tooltip_tip__2mxUl {
  position: absolute;
  z-index: 1;
  white-space: nowrap;
  background: var(--dylo-spotlight-bg, #2b2b2b);
  color: var(--dylo-spotlight-text, #fff);
  border: 1px solid var(--dylo-spotlight-border, rgba(255, 255, 255, 0.12));
  font-family: var(--font-sans);
  font-size: 12.5px;
  font-weight: 500;
  line-height: 1.2;
  padding: 7px 10px;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  pointer-events: none;
  transform-origin: center;
}

/* Variante para textos largos: varias líneas con ancho fijo (el ancla es muy
   pequeña, un ancho explícito evita el "shrink-to-fit" a una palabra por línea) */
.Tooltip_multiline__HXn7j {
  white-space: normal;
  width: 240px;
  max-width: 80vw;
  line-height: 1.4;
  text-align: left;
}

.Tooltip_arrow__O0V0W {
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
  border: inherit;
  transform: rotate(45deg);
}

/* ---- Placements + animación de aparición ---- */
.Tooltip_top__qx8F5 {
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  animation: Tooltip_tip-in-top__w67a0 0.16s ease both;
}
.Tooltip_top__qx8F5 .Tooltip_arrow__O0V0W {
  bottom: -5px;
  left: 50%;
  margin-left: -4px;
  border-top: none;
  border-left: none;
}

.Tooltip_bottom__eFIe2 {
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  animation: Tooltip_tip-in-bottom__3RGiB 0.16s ease both;
}
.Tooltip_bottom__eFIe2 .Tooltip_arrow__O0V0W {
  top: -5px;
  left: 50%;
  margin-left: -4px;
  border-bottom: none;
  border-right: none;
}

.Tooltip_left__gugyh {
  right: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
  animation: Tooltip_tip-in-left__4uxDS 0.16s ease both;
}
.Tooltip_left__gugyh .Tooltip_arrow__O0V0W {
  right: -5px;
  top: 50%;
  margin-top: -4px;
  border-bottom: none;
  border-left: none;
}

.Tooltip_right__2fg9j {
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
  animation: Tooltip_tip-in-right__qxeGH 0.16s ease both;
}
.Tooltip_right__2fg9j .Tooltip_arrow__O0V0W {
  left: -5px;
  top: 50%;
  margin-top: -4px;
  border-top: none;
  border-right: none;
}

@keyframes Tooltip_tip-in-top__w67a0 {
  from { opacity: 0; transform: translateX(-50%) translateY(4px) scale(0.96); }
  to { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
}
@keyframes Tooltip_tip-in-bottom__3RGiB {
  from { opacity: 0; transform: translateX(-50%) translateY(-4px) scale(0.96); }
  to { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
}
@keyframes Tooltip_tip-in-left__4uxDS {
  from { opacity: 0; transform: translateY(-50%) translateX(4px) scale(0.96); }
  to { opacity: 1; transform: translateY(-50%) translateX(0) scale(1); }
}
@keyframes Tooltip_tip-in-right__qxeGH {
  from { opacity: 0; transform: translateY(-50%) translateX(-4px) scale(0.96); }
  to { opacity: 1; transform: translateY(-50%) translateX(0) scale(1); }
}

@media (prefers-reduced-motion: reduce) {
  .Tooltip_top__qx8F5, .Tooltip_bottom__eFIe2, .Tooltip_left__gugyh, .Tooltip_right__2fg9j { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/v2/components/ui/Tooltip/Tooltip.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,6CAA6C;EAC7C,uCAAuC;EACvC,yEAAyE;EACzE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;kFACkF;AAClF;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,kDAAkD;AAClD;EACE,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,oDAAqC;AACvC;AACA;EACE,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,uDAAwC;AAC1C;AACA;EACE,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,qDAAsC;AACxC;AACA;EACE,WAAW;EACX,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,sDAAuC;AACzC;AACA;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,OAAO,UAAU,EAAE,uDAAuD,EAAE;EAC5E,KAAK,UAAU,EAAE,kDAAkD,EAAE;AACvE;AACA;EACE,OAAO,UAAU,EAAE,wDAAwD,EAAE;EAC7E,KAAK,UAAU,EAAE,kDAAkD,EAAE;AACvE;AACA;EACE,OAAO,UAAU,EAAE,uDAAuD,EAAE;EAC5E,KAAK,UAAU,EAAE,kDAAkD,EAAE;AACvE;AACA;EACE,OAAO,UAAU,EAAE,wDAAwD,EAAE;EAC7E,KAAK,UAAU,EAAE,kDAAkD,EAAE;AACvE;;AAEA;EACE,2FAA+B,eAAe,EAAE;AAClD","sourcesContent":[".wrap {\n  display: inline-flex;\n}\n\n/* Contenedor fijo (portal) que replica el rect del ancla */\n.anchor {\n  position: fixed;\n  z-index: 1300;\n  pointer-events: none;\n}\n\n.tip {\n  position: absolute;\n  z-index: 1;\n  white-space: nowrap;\n  background: var(--dylo-spotlight-bg, #2b2b2b);\n  color: var(--dylo-spotlight-text, #fff);\n  border: 1px solid var(--dylo-spotlight-border, rgba(255, 255, 255, 0.12));\n  font-family: var(--font-sans);\n  font-size: 12.5px;\n  font-weight: 500;\n  line-height: 1.2;\n  padding: 7px 10px;\n  border-radius: 8px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);\n  pointer-events: none;\n  transform-origin: center;\n}\n\n/* Variante para textos largos: varias líneas con ancho fijo (el ancla es muy\n   pequeña, un ancho explícito evita el \"shrink-to-fit\" a una palabra por línea) */\n.multiline {\n  white-space: normal;\n  width: 240px;\n  max-width: 80vw;\n  line-height: 1.4;\n  text-align: left;\n}\n\n.arrow {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  background: inherit;\n  border: inherit;\n  transform: rotate(45deg);\n}\n\n/* ---- Placements + animación de aparición ---- */\n.top {\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  animation: tip-in-top 0.16s ease both;\n}\n.top .arrow {\n  bottom: -5px;\n  left: 50%;\n  margin-left: -4px;\n  border-top: none;\n  border-left: none;\n}\n\n.bottom {\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  animation: tip-in-bottom 0.16s ease both;\n}\n.bottom .arrow {\n  top: -5px;\n  left: 50%;\n  margin-left: -4px;\n  border-bottom: none;\n  border-right: none;\n}\n\n.left {\n  right: calc(100% + 8px);\n  top: 50%;\n  transform: translateY(-50%);\n  animation: tip-in-left 0.16s ease both;\n}\n.left .arrow {\n  right: -5px;\n  top: 50%;\n  margin-top: -4px;\n  border-bottom: none;\n  border-left: none;\n}\n\n.right {\n  left: calc(100% + 8px);\n  top: 50%;\n  transform: translateY(-50%);\n  animation: tip-in-right 0.16s ease both;\n}\n.right .arrow {\n  left: -5px;\n  top: 50%;\n  margin-top: -4px;\n  border-top: none;\n  border-right: none;\n}\n\n@keyframes tip-in-top {\n  from { opacity: 0; transform: translateX(-50%) translateY(4px) scale(0.96); }\n  to { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }\n}\n@keyframes tip-in-bottom {\n  from { opacity: 0; transform: translateX(-50%) translateY(-4px) scale(0.96); }\n  to { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }\n}\n@keyframes tip-in-left {\n  from { opacity: 0; transform: translateY(-50%) translateX(4px) scale(0.96); }\n  to { opacity: 1; transform: translateY(-50%) translateX(0) scale(1); }\n}\n@keyframes tip-in-right {\n  from { opacity: 0; transform: translateY(-50%) translateX(-4px) scale(0.96); }\n  to { opacity: 1; transform: translateY(-50%) translateX(0) scale(1); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .top, .bottom, .left, .right { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Tooltip_wrap__FmTEH`,
	"anchor": `Tooltip_anchor__EM5eO`,
	"tip": `Tooltip_tip__2mxUl`,
	"multiline": `Tooltip_multiline__HXn7j`,
	"arrow": `Tooltip_arrow__O0V0W`,
	"top": `Tooltip_top__qx8F5`,
	"tip-in-top": `Tooltip_tip-in-top__w67a0`,
	"bottom": `Tooltip_bottom__eFIe2`,
	"tip-in-bottom": `Tooltip_tip-in-bottom__3RGiB`,
	"left": `Tooltip_left__gugyh`,
	"tip-in-left": `Tooltip_tip-in-left__4uxDS`,
	"right": `Tooltip_right__2fg9j`,
	"tip-in-right": `Tooltip_tip-in-right__qxeGH`
};
export default ___CSS_LOADER_EXPORT___;
